module.exports = __webpack_public_path__ + "static/media/gts33.81f21cc7.png";